export const COLORS = ["hsl(var(--chart-1))", "hsl(var(--chart-4))", "hsl(var(--chart-2))", "hsl(var(--chart-5))", "hsl(var(--chart-3))"];

export const SETTLEMENT_STATUS = {
  venter_signering: { label: "Venter på signering", cls: "bg-amber-500/10 text-amber-700 dark:text-amber-300 border-amber-500/20" },
  gjennomfort: { label: "Gjennomført", cls: "bg-emerald-500/10 text-emerald-700 dark:text-emerald-300 border-emerald-500/20" },
  kansellert: { label: "Kansellert", cls: "bg-muted text-muted-foreground border-border" },
};

export const UPLOAD_STATUS = {
  til_godkjenning: { label: "Til godkjenning", cls: "bg-amber-500/10 text-amber-700 dark:text-amber-300 border-amber-500/20" },
  godkjent: { label: "Godkjent", cls: "bg-emerald-500/10 text-emerald-700 dark:text-emerald-300 border-emerald-500/20" },
  avvist: { label: "Avvist", cls: "bg-red-500/10 text-red-700 dark:text-red-300 border-red-500/20" },
};

export const EMPTY = {
  date: "", seller_shareholder_id: "", share_class: "", shares: "", price_per_share: "", note: "",
  buyerKind: "existing", buyer_shareholder_id: "", buyer_name: "", buyer_id_number: "", buyer_email: "",
  seller_signatories: [], buyer_signatories: [], buyer_name_verified: false,
};
